export const FLOW_MODULE_NAME = 'flow'
export const FLOW_SET_NAME = 'FLOW_SET_NAME'
export const FLOW_SET_E2EFLOW = 'FLOW_SET_E2EFLOW'
export const FLOW_SET_COMPANY_ICON = 'FLOW_SET_COMPANY_ICON'
export const FLOW_SET_STATE_NAME = 'FLOW_SET_STATE_NAME'
export const FLOW_SET_STATE_TRANSITIONS = 'FLOW_SET_STATE_TRANSITIONS'
export const FLOW_SET_STATE_VIEW_CONTENT = 'FLOW_SET_STATE_VIEW_CONTENT'
export const FLOW_SET_STATE_VIEW_OPTIONS = 'FLOW_SET_STATE_VIEW_OPTIONS'
export const FLOW_SET_ERROR = 'FLOW_SET_ERROR'
export const FLOW_SET_COMPANY = 'FLOW_SET_COMPANY'
export const FLOW_SET_COMPANY_COLOR = 'FLOW_SET_COMPANY_COLOR'
